import React from 'react';

import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getTranslate, Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import Permissions from 'react-redux-permissions';
import { compose } from 'recompose';

import { EFieldType } from '../../../../models/EFieldType';
import { FkSwitch } from '../../../../ui/FkSwitch/FkSwitch';
import FormItemLayout from '../../../../ui/Forms/FormItemLayout';
import Tag from '../../../common/Tag';

const StyledFormItemLayout = styled(FormItemLayout)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  margin: theme.spacing(1, 0),
}));

const StyledLabelBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  height: '100%',
}));

type InnerProps = MappedProps;
type OuterProps = {};
type Props = InnerProps & OuterProps;

const ArchivedField = ({ translate }: Props) => {
  return (
    <Permissions allowed={['FlipdishStaff']}>
      <StyledFormItemLayout
        label={
          <StyledLabelBox>
            <Translate id="Archived" />
            <Tag noMargin showBetaTag tagName="Flipdish_staff_only" />
          </StyledLabelBox>
        }
        alignItems="center"
      >
        <Box display="flex" alignItems="center" height="100%">
          <FkSwitch
            required={false}
            fieldType={EFieldType.Boolean}
            name="isArchived"
            fdKey="isArchived"
          />
        </Box>
      </StyledFormItemLayout>
    </Permissions>
  );
};

type MappedProps = ReturnType<typeof mapStateToProps>;
const mapStateToProps = (state: AppState) => ({
  translate: getTranslate(state.locale),
});

export default compose<InnerProps, OuterProps>(connect(mapStateToProps))(ArchivedField);
